// RTK Query slice for giftcards (server-side pagination)
import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "./baseQuery";

export const giftcardsApi = createApi({
  reducerPath: "giftcardsApi",
  baseQuery: dynamicBaseQuery,
  refetchOnFocus: false,
  refetchOnReconnect: false,
  keepUnusedDataFor: 300,
  tagTypes: ["Giftcards"],
  endpoints: (builder) => ({
    getGiftcards: builder.query({
      query: ({
        page = 1,
        limit = 25,
        type,
        search,
        sortBy,
        sortOrder,
      } = {}) => {
        const params = new URLSearchParams();
        params.set("page", page);
        params.set("limit", limit);
        if (type && type !== "all") params.set("type", type);
        if (search) params.set("search", search);
        if (sortBy) params.set("sortBy", sortBy);
        if (sortOrder) params.set("sortOrder", sortOrder);
        return {
          url: `api/giftcards?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: ["Giftcards"],
    }),

    exportGiftcards: builder.query({
      query: ({ type, search, sortBy, sortOrder } = {}) => {
        const params = new URLSearchParams();
        params.set("export", "true");
        if (type && type !== "all") params.set("type", type);
        if (search) params.set("search", search);
        if (sortBy) params.set("sortBy", sortBy);
        if (sortOrder) params.set("sortOrder", sortOrder);
        return {
          url: `api/giftcards?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: ["Giftcards"],
    }),

    syncStripeGiftcards: builder.mutation({
      query: () => ({
        url: "api/giftcards/sync-stripe",
        method: "POST",
      }),
      invalidatesTags: ["Giftcards"],
    }),
  }),
});

export const {
  useGetGiftcardsQuery,
  useLazyExportGiftcardsQuery,
  useSyncStripeGiftcardsMutation,
} = giftcardsApi;
